import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useMediaQuery from 'react-use-media-query-hook';

import { Col, Row } from 'antd';
import Section from './Section';
import Button from '../../components/Button';
import PersonalContent from './Personal/Content';
import ConfirmationDeleteModal from '../../../admin/containers/ModalUser/ConfirmationDeleteModal';
import ROLES from '../../utils/roles';

export default function Account({ locales, locales: { account } }) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const history = useHistory();
  const {
    user: {
      current: { email, id, role, ssouserId },
    },
    users: { deleteLoading },
  } = useSelector((state) => state);
  const {
    user: { updateCurrentUser },
    users: { deactivateAccount },
  } = useDispatch();

  const [confirmationDeleteVisible, setConfirmationDeleteVisible] =
    useState(false);

  const handleOpenConfirmationModal = () => setConfirmationDeleteVisible(true);

  const handleCloseConfirmationModal = () =>
    setConfirmationDeleteVisible(false);

  const handleDeleteUser = (confirmationPassword) => {
    deactivateAccount({
      userId: id,
      confirmationPassword,
      afterSuccess: () => {
        handleCloseConfirmationModal();
        window.location.reload();
      },
    });
  };

  const showDeactivateButton = () => {
    return role !== ROLES.SUPER_ADMIN && ssouserId === null;
  };

  const isUserSSO = () => {
    return ssouserId !== null;
  };

  return (
    // eslint-disable-next-line react/style-prop-object
    <Section menuItems={account.menu} locales={locales} showAll={isMobile}>
      <section className="bmc-account" aria-label={account.title[0]}>
        <div className="bmc-form-big-title">{account.title[0]}</div>
        <div className="margin-top-10">{account.subtitle}</div>
        <Row align="bottom">
          <Col span={10}>
            <div className="bmc-form-fieldset margin-top-40 bmc-account-email-field-100">
              {isUserSSO() ? (
                <label htmlFor="email" className="bmc-form-label">
                  {account.ssoAccountIdentifier}
                </label>
              ) : (
                <label htmlFor="email" className="bmc-form-label">
                  {account.email}
                </label>
              )}
              <input
                id="email"
                className="bmc-form-input"
                value={email}
                disabled
                onChange={(e) =>
                  updateCurrentUser({
                    name: 'email',
                    value: e.target.value,
                  })
                }
                data-hj-allow
              />
            </div>
          </Col>
          {ssouserId === null && (
            <Col span={6} className="margin-left-10">
              <div>
                <Button onClick={() => history.push('/account/email')}>
                  {account.updateEmail}
                </Button>
              </div>
            </Col>
          )}
        </Row>
        {ssouserId === null && (
          <div className="bmc-form-fieldset margin-top-20">
            <span className="bmc-form-label">{account.password}</span>
            <Button onClick={() => history.push('/account/password')}>
              {account.updatePassword}
            </Button>
          </div>
        )}

        {/* temporary hide it <div className="bmc-form-text bmc-form-text--small bmc-form-text--upcase margin-top-10">
          {account.cantRemember}
          <Link
            to="/account/reset_password"
            className="bmc-form-link margin-left-10"
          >
            {account.resetPassword}
          </Link>
        </div> */}

        <div className="bmc-form-fieldset margin-top-40">
          <span className="bmc-form-label">{account.privacyInformation}</span>
          <div>{account.byCreatingAccount}</div>
          <div className="margin-top-15">
            <a
              href="https://simventure.com/terms-and-conditions/"
              target="_blank"
              className="bmc-form-link bmc-account-link"
            >
              {account.termsOfService}
            </a>
            <a
              href="https://simventure.com/policies/"
              className="bmc-form-link bmc-account-link"
              target="_blank"
            >
              {account.privacyPolicy}
            </a>
            <a
              href="https://simventure.com/terms-and-conditions/"
              className="bmc-form-link bmc-account-link"
              target="_blank"
            >
              {account.accessibility}
            </a>
          </div>
        </div>

        {showDeactivateButton() && (
          <div>
            <div className="bmc-form-line bmc-form-line--thin margin-top-30" />

            <div className="bmc-form-actions">
              <span
                className="bmc-form-action bmc-form-action--warn"
                onClick={handleOpenConfirmationModal}
              >
                {account.deactivateAccount}
              </span>
            </div>
          </div>
        )}
      </section>

      {isMobile && (
        <PersonalContent locales={locales} className="margin-top-20" />
      )}

      <ConfirmationDeleteModal
        loading={deleteLoading}
        visible={confirmationDeleteVisible}
        onClose={handleCloseConfirmationModal}
        onConfirm={handleDeleteUser}
      />
    </Section>
  );
}
